import { BooleanField, NumberField, TextField } from 'react-admin';

import { GetInstrumentOneResponse } from '@Common/types/bo/instruments';

import { ShowFields, ShowSection } from '@sh4res/bo-common/components';
import {
  instrumentStructuredProductTypeChoices,
  placementTypeChoices,
} from '@sh4res/bo-common/components/Instruments/choices';
import {
  CurrencyField,
  IdListField,
  SelectChipField,
  UTCDateField,
} from '@sh4res/bo-common/fields';

export const StructuredProductSection = () => (
  <>
    <ShowSection label="resources.bo_common.instruments.sections.statuses">
      <ShowFields<GetInstrumentOneResponse & { country_settings: string }>
        fields={{
          is_price_fetched: (
            <BooleanField
              source=""
              data-testid="BoExternalStructuredProductSection_IsPriceFetchedField"
            />
          ),
          is_enabled: (
            <BooleanField
              source=""
              data-testid="BoExternalStructuredProductSection_IsEnabledField"
            />
          ),
        }}
      />
    </ShowSection>
    <ShowSection label="resources.bo_common.instruments.sections.other">
      <ShowFields<GetInstrumentOneResponse>
        fields={{
          strike_date_at: (
            <UTCDateField data-testid="BoExternalStructuredProductSection_StrikeDateAtField" />
          ),
          issue_date_at: (
            <UTCDateField data-testid="BoExternalStructuredProductSection_IssueDateAtField" />
          ),
          marketing_date_start_at: (
            <UTCDateField data-testid="BoExternalStructuredProductSection_MarketingDateStartAtField" />
          ),
          marketing_date_end_at: (
            <UTCDateField data-testid="BoExternalStructuredProductSection_MarketingDateEndAtField" />
          ),
          maturity_date: (
            <UTCDateField data-testid="BoExternalStructuredProductSection_MaturityDateField" />
          ),
          issue_price_denomination_rate: (
            <NumberField
              transform={(val) => val * 100}
              data-testid="BoExternalStructuredProductSection_IssuePriceDenominationRateField"
            />
          ),
          issue_price_denomination_value: (
            <CurrencyField testId="BoExternalStructuredProductSection_IssuePriceDenominationValueField" />
          ),
          minimum_trading_size: (
            <CurrencyField testId="BoExternalStructuredProductSection_MinimumTradingSizeField" />
          ),
          management_company: (
            <TextField data-testid="BoExternalStructuredProductSection_ManagementCompanyField" />
          ),
          qty_decimal_places: (
            <NumberField data-testid="BoExternalStructuredProductSection_QtyDecimalPlacesField" />
          ),
          structured_product_type: (
            <SelectChipField
              choices={instrumentStructuredProductTypeChoices}
              data-testid="BoExternalStructuredProductSection_StructuredProductTypeField"
            />
          ),
          placement_type: (
            <SelectChipField
              choices={placementTypeChoices}
              data-testid="BoExternalStructuredProductSection_PlacementTypeField"
            />
          ),
          commission_to_third_parties_percentage_rate: (
            <NumberField
              transform={(val) => val * 100}
              data-testid="BoExternalStructuredProductSection_CommissionToThirdPartiesPercentageRateField"
            />
          ),
          one_off_entry_cost_percentage_rate: (
            <NumberField
              transform={(val) => val * 100}
              data-testid="BoExternalStructuredProductSection_OneOffEntryCostPercentageRateField"
            />
          ),
          running_cost_percentage_rate: (
            <NumberField
              transform={(val) => val * 100}
              data-testid="BoExternalStructuredProductSection_RunningCostPercentageRateField"
            />
          ),
          wm_company_ids: (
            <IdListField
              source=""
              reference="wm/companies" // eslint-disable-line regex/invalid -- no need for useResourceBasePath as SP are only displayed in internal BO
              maxItems={100}
              testId="BoExternalStructuredProductSection_WmCompanyIdsField"
            />
          ),
          last_nav_date: (
            <UTCDateField data-testid="BoExternalStructuredProductSection_LastNavDateField" />
          ),
          last_nav: (
            <CurrencyField
              currency="EUR"
              testId="BoExternalStructuredProductSection_LastNavField"
            />
          ),
          nav_cut_off_buy: (
            <TextField data-testid="BoExternalStructuredProductSection_NavCutOffBuyField" />
          ),
          nav_cut_off_sell: (
            <TextField data-testid="BoExternalStructuredProductSection_NavCutOffSellField" />
          ),
          admin_cut_off_buy: (
            <TextField data-testid="BoExternalStructuredProductSection_AdminCutOffBuyField" />
          ),
          admin_cut_off_sell: (
            <TextField data-testid="BoExternalStructuredProductSection_AdminCutOffSellField" />
          ),
        }}
      />
    </ShowSection>
  </>
);
